import { useHistory } from 'react-router-dom';

import * as graphql from '@treams/treams-network';

import SettingsCollection, { ArchiveRestoreMutationTuple } from '../generic/SettingsCollection';

export default function SettingsTeams() {
	const history = useHistory();

	return (
		<SettingsCollection
			query={graphql.useTeamsQuery}
			lazyQuery={graphql.useTeamsLazyQuery}
			field="groups"
			translationKey="settings.teams"
			title={(team: graphql.Group) => team.name}
			link={(title) => `/settings/organization/teams/${title.id}`}
			variables={{}}
			archive={graphql.useArchiveGroupMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreGroupMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/organization/teams/new')}
		/>
	);
}
